import React, { FC, ReactNode, forwardRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { Box, useTheme } from '@mui/material';

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
}

const Scrollbar = forwardRef<any, ScrollbarProps>(({ className, children, ...rest }, ref) => {
  const theme = useTheme();
  return (
    <Scrollbars
      ref={ref}
      autoHide={false}
      autoHideTimeout={0}
      hideTracksWhenNotNeeded={false}
      renderTrackVertical={() => {
        return (
          <Box
            sx={{
              width: 12,
              left: 0,
              right: 'auto',
              height: '100%',
              position: 'absolute',
              backgroundColor: 'transparent'
            }}
          />
        );
      }}
      renderThumbVertical={() => {
        const isDark = theme.palette.mode === 'dark';
        return (
          <Box
            sx={{
              width: 5,
              background: isDark ? theme.colors.alpha.trueWhite[30] : theme.colors.alpha.white[70],
              borderRadius: `${theme.general.borderRadiusLg}`,
              transition: `${theme.transitions.create(['background'])}`,
              position: 'relative',
              left: '2px',
              '&:hover': {
                background: isDark ? theme.colors.alpha.trueWhite[50] : theme.colors.alpha.white[100]
              }
            }}
          />
        );
      }}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
});

export default Scrollbar;
